import React, { useEffect, useState } from 'react';
import './About.css';
import logoBlue from '../assets/logos/Logo Blue Text PNG  .png';
import PageHero from '../components/PageHero';

const teamMembers = [
  {
    id: 1,
    name: 'Sarah Johnson',
    position: 'Chief Executive Officer',
    bio: `With over 15 years of industry experience, Sarah has led our company to new heights with her visionary leadership and strategic thinking. She began her career in marketing before transitioning to operations and eventually taking on the role of CEO. Under her guidance, the company has expanded into new markets and doubled its revenue. Sarah is known for her ability to inspire teams and create a culture of innovation and excellence. Her forward-thinking approach and commitment to sustainable business practices have positioned our company as an industry leader.`,
    skills: ['Leadership', 'Strategy'],
    color: '#1E5EAB',
    accent: '#3a7fcf',
    image: 'https://www.shutterstock.com/image-photo/portrait-handsome-man-black-suit-600nw-460050457.jpg',
  },
  {
    id: 2,
    name: 'Michael Chen',
    position: 'Chief Technology Officer',
    bio: `Michael's innovative approach to technology has revolutionized our product development process and kept us at the cutting edge of the industry. With a background in quantum computing and artificial intelligence, he brings a unique perspective to solving complex technical challenges. His leadership has resulted in multiple patents and award-winning products. Michael is passionate about creating technology that makes a positive impact on people's lives. He leads our R&D team with a focus on both short-term solutions and long-term technological advancement.`,
    skills: ['Innovation', 'Tech'],
    color: '#2a6fbd',
    accent: '#4b90e0',
    image: 'https://i.pinimg.com/736x/a2/95/0f/a2950faa53be5e2872037f1027fdfbe3.jpg',
  },
  {
    id: 3,
    name: 'Elena Rodriguez',
    position: 'Creative Director',
    bio: `Elena's creative vision has shaped our brand identity and helped us connect with audiences through compelling visual storytelling. Her background in fine arts and digital design gives her a versatile approach to creative challenges. She leads a team of designers who consistently produce award-winning work across multiple platforms. Elena believes that great design is both beautiful and functional, solving real problems while creating emotional connections. Her work has been recognized internationally and has helped establish our distinctive brand presence in a competitive market.`,
    skills: ['Design', 'Creativity'],
    color: '#174a87',
    accent: '#2a6fbd',
    image: 'https://media.istockphoto.com/id/493116226/photo/happy-smiling-businessman-in-suit.jpg?s=612x612&w=0&k=20&c=JSuvCrREfPOIxvXoyHWbVOl1LG7vT7TQzK6ZO203EuA=',
  },
  {
    id: 4,
    name: 'James Taylor',
    position: 'Operations Director',
    bio: `James has streamlined our operations and improved efficiency across all departments with his methodical approach and attention to detail. His background in supply chain management and process optimization has been invaluable in scaling our operations while maintaining quality and customer satisfaction. James is committed to sustainable business practices and has implemented eco-friendly initiatives throughout our supply chain. His leadership has been crucial in maintaining operational excellence during periods of rapid growth.`,
    skills: ['Operations', 'Management'],
    color: '#3a7fcf',
    accent: '#5b9fe0',
    image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?auto=format&fit=facearea&w=600&h=900&q=80',
  },
  {
    id: 5,
    name: 'Aisha Patel',
    position: 'Marketing Director',
    bio: `Aisha's innovative marketing strategies have significantly expanded our market reach and strengthened our brand presence globally. Her expertise in digital marketing and consumer psychology has helped us connect with new audiences and build lasting customer relationships across diverse markets. Aisha is known for her data-driven approach combined with creative storytelling. She has pioneered several successful campaigns that have set new benchmarks in the industry and significantly contributed to our company's growth.`,
    skills: ['Marketing', 'Strategy'],
    color: '#2a6fbd',
    accent: '#4b90e0',
    image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=facearea&w=600&h=900&q=80',
  },
  {
    id: 6,
    name: 'Robert Kim',
    position: 'Financial Analyst',
    bio: `Robert's financial expertise has been instrumental in optimizing our resource allocation and ensuring sustainable growth. His analytical skills and strategic thinking have helped us navigate complex financial challenges and identify new opportunities for investment and expansion. Robert combines traditional financial acumen with innovative approaches to funding and investment. His forecasting models have proven remarkably accurate, allowing the company to make confident decisions even in uncertain market conditions.`,
    skills: ['Finance', 'Analysis'],
    color: '#174a87',
    accent: '#2a6fbd',
    image: 'https://images.unsplash.com/photo-1511367461989-f85a21fda167?auto=format&fit=facearea&w=600&h=900&q=80',
  },
];

const About = () => {
  const [modalMember, setModalMember] = useState(null);
  const [showAllMembers, setShowAllMembers] = useState(false);
  
  useEffect(() => {
    const animatedElements = document.querySelectorAll('.animate-fade-in');
    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });
    
    animatedElements.forEach(element => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  // Close modal when clicking outside content
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalMember && !e.target.closest('.modal-content')) {
        setModalMember(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [modalMember]);

  return (
    <div className="about-page-root">
      <PageHero
        title="Our Story"
        subtitle="We're a team of filmmakers, strategists, and technologists crafting stories people replay."
        align="left"
      />

      {/* About Us Section */}
      <section className="about-us-section">
        <div className="container">
          <div className="about-grid">
            <div className="animate-fade-in">
              <div className="logo-container">
                <img src={logoBlue} alt="Company Logo" className="company-logo" />
              </div>
            </div>
            <div className="animate-fade-in about-content">
              <h2>Who We Are</h2>
              <p>Founded in 2010, our company has grown from a small startup to an industry leader. We believe in pushing boundaries and challenging the status quo to deliver exceptional results for our clients.</p>
              <p>Our diverse team brings together expertise from various fields, creating a dynamic environment where innovation thrives and excellence is the standard.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <h2 className="animate-fade-in">Meet Our Team</h2>
            <p className="animate-fade-in">The brilliant minds behind our success. Each member brings unique expertise and passion to our collective mission.</p>
          </div>
          <div className="team-grid" id="teamGrid">
            {(showAllMembers ? teamMembers : teamMembers.slice(0, 3)).map((member, idx) => (
              <div
                className={`team-card animate-fade-in ${showAllMembers || idx < 3 ? 'visible' : ''}`}
                key={member.id}
                onClick={() => {
                  console.log('Opening modal for', member.name);
                  setModalMember(member);
                }}
              >
                <div className="team-card-image">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="team-member-img"
                  />
                </div>
                <div className="team-card-content">
                  <div className="team-member-name">{member.name}</div>
                  <div className="team-member-position">{member.position}</div>
                  <div className="team-member-bio">{member.bio.split('.').slice(0, 2).join('. ') + '.'}</div>
                  <div className="team-member-skills">
                    {member.skills.map(skill => (
                      <span key={skill} className="skill-tag">{skill}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Meet More Team Members Button */}
          {!showAllMembers && (
            <div className="show-more-container">
              <button
                className="show-more-btn"
                onClick={() => setShowAllMembers(true)}
              >
                Meet More Members
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Our Core Values Section */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Core Values</h2>
            <p>The principles that guide everything we do and define who we are as a team.</p>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" fill="none" stroke="#1E5EAB" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
              </div>
              <div className="value-title">Innovation</div>
              <div className="value-description">We constantly push boundaries and challenge the status quo to create breakthrough solutions.</div>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" fill="none" stroke="#1E5EAB" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M8 12h8M12 8v8"/></svg>
              </div>
              <div className="value-title">Collaboration</div>
              <div className="value-description">We believe in the power of diverse perspectives coming together to achieve extraordinary results.</div>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" fill="none" stroke="#1E5EAB" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M12 17.09l6.16-3.7A2 2 0 0020 11.18V7a2 2 0 00-2-2H6a2 2 0 00-2 2v4.18a2 2 0 00.84 1.61L12 17.09z"/><circle cx="12" cy="12" r="10"/></svg>
              </div>
              <div className="value-title">Integrity</div>
              <div className="value-description">We uphold the highest ethical standards in all our interactions and decisions.</div>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" fill="none" stroke="#1E5EAB" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M8 15s1.5 2 4 2 4-2 4-2"/><circle cx="9" cy="10" r="1"/><circle cx="15" cy="10" r="1"/></svg>
              </div>
              <div className="value-title">Passion</div>
              <div className="value-description">We bring enthusiasm and dedication to everything we do, driving excellence in all our endeavors.</div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal for member details */}
      {modalMember && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-image-container">
              <img
                src={modalMember.image}
                alt={modalMember.name}
                className="modal-member-img"
              />
              <div className="modal-image-overlay">
                <div className="modal-member-name">{modalMember.name}</div>
                <div className="modal-member-position">{modalMember.position}</div>
              </div>
            </div>
            <div className="modal-text-content">
              <div className="modal-text-header">
                <div className="modal-text-name">{modalMember.name}</div>
                <div className="modal-text-position">{modalMember.position}</div>
              </div>
              <div className="modal-bio-section">
                <div className="modal-bio-title">About</div>
                <div className="modal-bio-text">{modalMember.bio}</div>
              </div>
            </div>
            <button
              onClick={() => setModalMember(null)}
              className="modal-close-btn"
              aria-label="Close"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default About;